import { module } from "angular";
import { SitesWidgetComponent } from "./SitesWidgetComponent";

module("mmGui").component("mmSitesWidget", new SitesWidgetComponent());
